import React from 'react';
import ReactDOM from 'react-dom';
import { act } from 'react-dom/test-utils';

// browser-image-compression / heic2any は jsdom(Worker 無し) で import 時に落ちる。
jest.mock('../../lib/image_compressor', () => jest.fn());
jest.mock('../axios', () => ({ post: jest.fn() }));
jest.mock('../../lib/talkroom_ai_precheck', () => ({
  requestPrecheck: jest.fn(),
}));

// eslint-disable-next-line import/first
import axios from '../axios';
// eslint-disable-next-line import/first
import { requestPrecheck } from '../../lib/talkroom_ai_precheck';
// eslint-disable-next-line import/first
import UserfeedSendForm from './userfeed_send_form';

// @context TGW-2311 送信前 AI 警告の Web 側の配線（§13 契約表）。
//   判定ロジックは lib/talkroom_ai_precheck.js に寄せているが、契約表 12（多重送信の抑止）は
//   このコンポーネントの state にしか無い挙動なので、ヘルパー側のテストでは代替できない。
describe('UserfeedSendForm の送信前 AI 警告', () => {
  let container;

  const warningResponse = {
    warn: true,
    precheckId: 7,
    title: 'このメッセージは相手に強い不安を与える可能性があります。',
    message: '内容を見直しますか？',
  };

  const render = () => {
    act(() => {
      ReactDOM.render(
        <UserfeedSendForm
          userfeedId={42}
          loadNewReply={() => {}}
          selectedReply={null}
          onPressCloseButton={() => {}}
        />,
        container
      );
    });
  };

  const typeReply = (value) => {
    const textarea = container.querySelector('#ta-message');
    act(() => {
      const setter = Object.getOwnPropertyDescriptor(
        window.HTMLTextAreaElement.prototype,
        'value'
      ).set;
      setter.call(textarea, value);
      textarea.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const clickSubmit = async () => {
    const button = container.querySelector('#btnMessageSubmit');
    await act(async () => {
      button.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    });
  };

  const clickModalButton = async (label) => {
    const link = Array.from(container.querySelectorAll('a')).find(
      (a) => a.textContent === label
    );
    await act(async () => {
      link.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    });
  };

  const postedFormData = () => axios.post.mock.calls[0][1];

  beforeEach(() => {
    // ModalConfirm の closeModal が jQuery でスクロール位置を戻す
    global.$ = () => ({ scrollTop: () => {} });
    container = document.createElement('div');
    document.body.appendChild(container);
    axios.post.mockReset();
    axios.post.mockResolvedValue({ data: {} });
    requestPrecheck.mockReset();
    requestPrecheck.mockResolvedValue({
      warn: false,
      precheckId: null,
      title: null,
      message: null,
    });
    render();
  });

  afterEach(() => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
    delete global.$;
  });

  // 契約表 3、1、2
  it('warn=true なら確認モーダルを出す。文言はサーバーが返したものを表示する', async () => {
    requestPrecheck.mockResolvedValue(warningResponse);
    typeReply('今から行くね');
    await clickSubmit();

    expect(container.textContent).toContain(warningResponse.title);
    expect(container.textContent).toContain(warningResponse.message);
    const links = Array.from(container.querySelectorAll('a')).map(
      (a) => a.textContent
    );
    // 左が「見直す」、右が「このまま送信」
    expect(links).toEqual(['見直す', 'このまま送信']);
    expect(axios.post).not.toHaveBeenCalled();
  });

  // 契約表 10
  it('「このまま送信」で ai_precheck_id を付けて投稿する', async () => {
    requestPrecheck.mockResolvedValue(warningResponse);
    typeReply('今から行くね');
    await clickSubmit();

    await clickModalButton('このまま送信');

    expect(axios.post).toHaveBeenCalledTimes(1);
    expect(postedFormData().get('ai_precheck_id')).toBe('7');
    expect(postedFormData().get('reply')).toBe('今から行くね');
  });

  // 契約表 11
  it('「見直す」なら投稿せず、入力内容を保持したまま編集に戻る', async () => {
    requestPrecheck.mockResolvedValue(warningResponse);
    typeReply('今から行くね');
    await clickSubmit();

    await clickModalButton('見直す');

    expect(axios.post).not.toHaveBeenCalled();
    expect(container.querySelector('#ta-message').value).toBe('今から行くね');
    expect(container.querySelector('#btnMessageSubmit').disabled).toBe(false);
  });

  // 契約表 4
  it('warn=false ならそのまま送信し、ai_precheck_id を付ける', async () => {
    requestPrecheck.mockResolvedValue({
      warn: false,
      precheckId: 3,
      title: null,
      message: null,
    });
    typeReply('こんにちは');
    await clickSubmit();

    expect(axios.post).toHaveBeenCalledTimes(1);
    expect(postedFormData().get('ai_precheck_id')).toBe('3');
  });

  // 契約表 5〜8（ヘルパーが fail-open で返す）
  it('判定できなかった場合はそのまま送信し、ai_precheck_id を付けない', async () => {
    typeReply('こんにちは');
    await clickSubmit();

    expect(axios.post).toHaveBeenCalledTimes(1);
    expect(postedFormData().get('ai_precheck_id')).toBeNull();
  });

  // 契約表 9
  it('本文が空（画像のみ）なら precheck を呼ばない', async () => {
    const form = container.querySelector('#message-photo');
    await act(async () => {
      Object.defineProperty(form, 'files', {
        value: [new File(['x'], 'a.png', { type: 'image/png' })],
      });
      form.dispatchEvent(new Event('change', { bubbles: true }));
    });

    await clickSubmit();

    expect(requestPrecheck).not.toHaveBeenCalled();
    expect(axios.post).toHaveBeenCalledTimes(1);
  });

  // 契約表 12。これが破れると、モーダルの選択を待たずに送信できて警告機能が素通しになる。
  it('確認モーダルを開いている間は送信ボタンが無効', async () => {
    requestPrecheck.mockResolvedValue(warningResponse);
    typeReply('今から行くね');
    await clickSubmit();

    expect(container.querySelector('#btnMessageSubmit').disabled).toBe(true);

    await clickSubmit();

    expect(axios.post).not.toHaveBeenCalled();
    expect(requestPrecheck).toHaveBeenCalledTimes(1);
  });

  it('precheck の待ち時間中も送信ボタンが無効（有料 API の二重消費を防ぐ）', async () => {
    let resolvePrecheck;
    requestPrecheck.mockReturnValue(
      new Promise((resolve) => {
        resolvePrecheck = resolve;
      })
    );
    typeReply('今から行くね');
    await clickSubmit();

    expect(container.querySelector('#btnMessageSubmit').disabled).toBe(true);

    await clickSubmit();
    expect(requestPrecheck).toHaveBeenCalledTimes(1);

    await act(async () => {
      resolvePrecheck({ warn: false, precheckId: null });
    });
  });

  it('送信が失敗しても loading が戻る（入力欄が固まらない）', async () => {
    axios.post.mockRejectedValue(new Error('boom'));
    jest.spyOn(console, 'error').mockImplementation(() => {});
    typeReply('こんにちは');

    await clickSubmit();

    expect(container.querySelector('#btnMessageSubmit').disabled).toBe(false);
    console.error.mockRestore();
  });
});
